import { inject } from 'tsyringe'
import { Store } from 'vuex'
import { ClientOnly } from '~/decorators'
import { containerScoped } from '~/decorators/dependency-container'
import { Policy } from '~/models/shared/types'
import { RootState } from '~/store/types'

@ClientOnly
@containerScoped()
export class PrivacyPolicyChecker {
  constructor(@inject(Store) private store: Store<RootState>) {}

  policyWithNameExists(policy: Policy): boolean {
    const { policies } = this.store.state.page
    return policies.includes(policy)
  }
}
